<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div class="home__image">
      <!-- <img id="witch" src="../assets/witch_home.png" alt="witch_home" /> -->
      <div id="witch-home"></div>
    </div>
    <div class="home__text">
      <div class="home__title">
        <h1>Pumpkin Time!</h1>
      </div>
      <div class="home__subtitle">
        <h2>Help the witch learn how to read the time!</h2>
        <br />
      </div>
      <button class="home__start-button" @click="clickStart">Start</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import lottie from 'lottie-web/build/player/lottie';
// import { Howl } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  computed: {
    ...mapGetters({ homeScreenStatus: 'pumpkinClock/homeScreenStatus' }),
  },
  mounted() {
    const witchHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('witch-home'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: '/assets/practices/pumpkin_clock/animations/witch_home.json',
    });
    witchHomeAnimation.play();
  },
  methods: {
    ...mapActions({ homeClickStart: 'pumpkinClock/homeClickStart' }),
    clickStart() {
      sounds.globalButton.play();
      this.homeClickStart();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  background-color: #84c8f5;
  background-image: url('~@/assets/practices/pumpkin_clock/background_home.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  padding: 2vw;
  height: 100vh;
  font-family: 'VanillaExtractRegular';
}

.home__text {
  text-align: center;
  transform: translateY(-6.5vw);
  width: 50vw;
}

.home__title {
  color: $pumpkin-clock-color-main;
  font-size: 6vh;
}

.home__subtitle {
  color: $pumpkin-clock-color-alt-third;
  font-size: 4vh;
}

.home__image {
  @include flex-center;
  width: 50vw;

  #witch-home {
    width: 100%;
  }
}
</style>
